import axios from 'axios'

axios.defaults.headers.common['Content-Type'] = 'application/json'

const appConfig = {
  layoutAndModuleWidth: '29em',
  subscriptionAgreementWidth: {
    layoutWidth: '48em',
    moduleWidth: '55em',
  },
  disableLoggingErrorService:
    process.env.NODE_ENV === 'development' ? true : false,
}

export default appConfig
